<template>
    <el-form-item :prop="prop">
        <el-input
            ref="customInput"
            v-model="inputValue"
            :input-style="inputStyles"
            :placeholder="placeholder"
            :type="type"
            :rows="rows"
            :name="name"
            :disabled="disabled"
            :class="classes"
            :id="id"
            :required="required"
            :autocomplete="autocomplete"
            @input="$emit('onInput', inputValue)"
        />
    </el-form-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ElFormItem, ElInput } from 'element-plus';
import { CustomInput } from '@/components/logics/inputs/CustomInput';

export default defineComponent({
  name: 'custom-input',
  components: { ElFormItem, ElInput },
  props: {
    prop: {
      type: String,
      default: ''
    },
    ref: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    rows: {
      type: String,
      default: '1'
    },
    name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    classes: {
      type: String,
      default: ''
    },
    inputStyles: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: true
    },
    isForm: {
      type: Boolean,
      default: true
    },
    autocomplete: {
      type: String,
      default: 'off'
    }
  },
  setup(props, { emit }) {
    return CustomInput(props, { emit });
  },
  watch: {
    value(val) {
      this.inputValue = val;
    }
  }
});
</script>
